import Vue from 'vue';

import { defineCustomElements } from '@campusedu/date-picker/dist/loader';
import '@campusedu/date-picker/dist/collection/themes/default.css';

// Configure Vue to ignore Duet Date picker
// eslint-disable-next-line no-param-reassign
Vue.config.ignoredElements = [ /duet-\w*/ ];
defineCustomElements( window );
